module.exports = __webpack_public_path__ + "img/military_hq-stage_5.30e38682.jpg";